<dialog
    ctrlModal
    [dismissable]="false"
    class="-with-buttons no-header"
    aria-labelledby="cookie-modal-title"
>
    <form
        [formGroup]="form"
        (submit)="submit()"
        [ngClass]="{ 'not-info': settingsMode !== 'info' }"
    >
        <div class="modal-content">
            @if (settingsMode === 'general' || settingsMode === 'detailed') {
                <h2 id="cookie-modal-title">Cookies</h2>
                <p class="m-0 fs:s sm:fs:m">
                    Wir verwenden Cookies, um dir ein optimales Webseiten-Erlebnis zu bieten. Dazu zählen Cookies, die
                    für den Betrieb der Seite notwendig sind, sowie solche, die zur Medienwiedergabe bzw.
                    Komfortfunktionen verwendet werden. Du kannst selbst entscheiden, welche Kategorien du zulassen
                    möchtest. Bitte beachte, dass auf Basis deiner Auswahl womöglich nicht mehr alle Funktionalitäten
                    der Seite zur Verfügung stehen. Weitere Informationen findest du in unserer
                    <button
                        class="btn-link"
                        type="button"
                        (click)="settingsMode = 'info'"
                    >
                        Datenschutzerklärung</button
                    >.
                </p>

                @if (settingsMode === 'detailed') {
                    <div class="p-12:t md:p-16:t lg:p-24:t">
                        <input
                            type="checkbox"
                            id="cookies-necessary"
                            formControlName="necessary"
                        />
                        <label for="cookies-necessary">Notwendig</label>
                        <input
                            type="checkbox"
                            id="cookies-google"
                            formControlName="google"
                        />
                        <label for="cookies-google">Google Analytics</label>
                        <input
                            type="checkbox"
                            id="cookies-meta"
                            formControlName="meta"
                        />
                        <label for="cookies-meta">Meta Conversion Tracking</label>
                    </div>
                }
            } @else if (settingsMode === 'info') {
                <app-general-privacy-statement></app-general-privacy-statement>
            }
        </div>
        <div class="modal-buttons">
            @switch (settingsMode) {
                @case ('general') {
                    <div class="grid-container -spread-content p-12:t md:p-16:t lg:p-24:t">
                        <div class="g-12 xs:g-6 sm:g-3 m-6:b xs:m-0:b">
                            <button
                                type="button"
                                class="button -full-width -ghost -dark"
                                (click)="settingsMode = 'detailed'"
                            >
                                Einstellungen
                            </button>
                        </div>
                        <div class="g-12 xs:g-6 sm:g-3">
                            <button
                                type="button"
                                class="button"
                                (click)="acceptAll()"
                            >
                                Alle erlauben
                            </button>
                        </div>
                    </div>
                }
                @case ('detailed') {
                    <div class="grid-container -spread-content">
                        <div class="g-12 xs:g-6 sm:g-3 m-6:b xs:m-0:b">
                            <button
                                type="submit"
                                class="button -full-width -ghost -dark"
                            >
                                Speichern
                            </button>
                        </div>
                        <div class="g-12 xs:g-6 sm:g-3">
                            <button
                                type="button"
                                class="button"
                                (click)="acceptAll()"
                            >
                                Alle erlauben
                            </button>
                        </div>
                    </div>
                }
                @case ('info') {
                    <div class="grid-container">
                        <button
                            type="button"
                            class="button -ghost -full-width -dark g-12 xs:g-6 sm:g-3"
                            (click)="settingsMode = 'detailed'"
                        >
                            Zurück
                        </button>
                    </div>
                }
            }
        </div>
    </form>
</dialog>
